import { useSearchParams } from "react-router-dom";
import { Table } from "../../../../../../components/Functional";
import { Modal, Button } from "../../../../../../components/ui";
import AddDocuments from "./components/AddDocuments";
import Actions from "./components/Actions";
import { FETCH_SHIPMENT_DOCUMENTS } from "../../../../../../graphql/query/ShipmentDocument";
import Header from "./components/Header";
import SectionHeader from "../../components/SectionHeader";
import {
  DOCUMENT_FILE_NAME_LABEL_CLASS,
  DOCUMENT_HIGHLIGHT_ROW_CLASS,
  matchesDocumentFilename,
} from "../../../../../../util/documentLink";

const ShipmentDocuments = props => {
  const { shipmentId, shipment, formik } = props || {};
  const [searchParams] = useSearchParams();
  const highlightedFilename = searchParams.get("filename");

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "shipmentDocuments",
    headers: [
      {
        label: "File Name",
        name: "fileName",
        type: "label",
        labelClass: DOCUMENT_FILE_NAME_LABEL_CLASS,
        widthInPx: 360,
        width: "45%",
      },
      { label: "File Type", name: "fileType", type: "label" },
      { label: "Date", name: "updatedAt", type: "date" },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [{ label: "Name", name: "name", type: "text", view: "partial" }],
    FETCH_QUERY: FETCH_SHIPMENT_DOCUMENTS,
    variables: {
      shipmentId: +shipmentId,
    },
    rowClassName: values =>
      matchesDocumentFilename(values?.fileName, highlightedFilename)
        ? DOCUMENT_HIGHLIGHT_ROW_CLASS
        : "",
  };

  const modalProps = {
    body: AddDocuments,
    closeOnBackdrop: true,
    shipment,
    hideCloseButton: true,
    scale: "md",
  };

  const actions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button label="Upload" action="black" />
          </Modal>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Documents" actions={actions} />
      <Header formik={formik} submitOnBlur={true} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default ShipmentDocuments;
